import React from "react";
import styled from "styled-components";

// context
import { useSearchBar } from "core/SearchBar/context/useSearchBar.js";

// components
import FormSelectDialogCaret from "core/FormSelectDialog/variations/FormSelectDialogCaret";
import {
    ControlStyled,
    ContentWrapperStyled
} from "core/FormSelectDialog/components/Control.js";
import { DialogStyled } from "core/FormSelectDialog/components/Dialog.js";
import { DialogOptionStyled } from "core/FormSelectDialog/components/DialogOption.js";
import { Image as CaretDownIcon } from "core/ReusableIcons/CaretDown";

// styles
import breakpoints from "core/breakpoints";
import { getBorderStyles } from "../index";
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
const FormSelectDialogCaretStyled = styled(FormSelectDialogCaret)`
    flex: 0 1 auto;
    height: 100%;

    ${ControlStyled} {
        font-size: ${({ $fontSize }) => convertPxToRem($fontSize)};

        border: none;

        border-top: ${({ $borderStyles }) => $borderStyles.border};
        border-bottom: ${({ $borderStyles }) => $borderStyles.border};
        border-left: ${({ $borderStyles }) => $borderStyles.border};

        &:focus {
            outline: none;
            border-color: ${({ $borderStyles }) => $borderStyles.focusColor};
        }

        &:hover {
            background-color: ${colors.primary.moon};
            border-color: ${({ $borderStyles }) => $borderStyles.hoverColor};
        }

        ${ContentWrapperStyled} {
            gap: ${convertPxToRem(5)};
            @media (min-width: ${breakpoints.tablet.rem}) {
                gap: ${convertPxToRem(12)};
            }

            ${CaretDownIcon} {
                width: ${convertPxToRem(10)};
                height: ${convertPxToRem(10)};
            }
        }
    }

    ${DialogStyled} {
        ul {
            z-index: 2;
            font-size: ${({ $fontSize }) => convertPxToRem($fontSize)};
            width: ${convertPxToRem(205)};
            top: 0rem;
        }
    }

    ${DialogOptionStyled} {
        font-size: ${({ $fontSize }) => convertPxToRem($fontSize)};
    }
`;

// component
const FormSelectDialog = () => {
    const {
        id,
        isDarkMode,
        dropDown,
        setSelectedOption,
        isDisabled
    } = useSearchBar();
    const { selectedOption, options } = dropDown;
    const onSelect = option => {
        setSelectedOption(option);
    };

    return (
        <FormSelectDialogCaretStyled
            $isDarkMode={isDarkMode}
            $fontSize={15}
            $borderStyles={getBorderStyles(isDarkMode)}
            id={`search-the-noun-project-by-type-${id}`}
            label="Search Type"
            options={options}
            selectedOption={selectedOption}
            setSelectedOption={onSelect}
            isDisabled={isDisabled}
            hideOnScroll
        />
    );
};

export default FormSelectDialog;
